import {
  ReferenceControl,
  ReferenceValue,
} from '../../../../../../types/types';

interface IsReferenceLabelLookupOptions {
  // Set only when fetching labels for preselected ids (idItem `in` value).
  valueFilter: ReferenceValue | null;
  idItem: ReferenceControl['idItem'];
  labelItem: ReferenceControl['labelItem'];
}

// True when resolving the display label for a preselected id. idItem is a unique
// key, so control.filter is redundant here and can wrongly exclude the row.
export const isReferenceLabelLookup = ({
  valueFilter,
  idItem,
  labelItem,
}: IsReferenceLabelLookupOptions): boolean =>
  Boolean(valueFilter) && Boolean(labelItem) && idItem !== labelItem;
